import React from 'react';
import PropTypes from 'prop-types';

const CardInfoBlock = ({
  secondaryTitle,
  primaryTitle,
  meta,
  accessibility,
}) => (
  <div className="Card__InfoBlock">
    {accessibility !== false &&
      <span
        className="sr-only"
        role="heading"
        aria-level="3"
      >
        {secondaryTitle && secondaryTitle + (primaryTitle ? ' - ' : '')}{primaryTitle && primaryTitle}
      </span>
     }
    {secondaryTitle && <div className="Card__InfoBlock_title">{secondaryTitle}</div>}
    {primaryTitle && <div className="Card__InfoBlock_description">{primaryTitle}</div>}
    {meta && <div className="Card__InfoBlock_meta">{meta}</div>}
  </div>
);

CardInfoBlock.propTypes = {
  secondaryTitle: PropTypes.string,
  primaryTitle: PropTypes.string,
  meta: PropTypes.string,
  accessibility: PropTypes.bool,
};

CardInfoBlock.defaultProps = {
  secondaryTitle: null,
  primaryTitle: null,
  meta: null,
  accessibility: true,
};

export default CardInfoBlock;
